import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DocentesDependenciaUaaDto } from 'src/app/dto/docentes-dependencia-uaa-dto';
import { EvadocInfoDto } from 'src/app/dto/evadoc-info-dto';
import { EvaluadosDto } from 'src/app/dto/evaluados-dto';
import { ParesDto } from 'src/app/dto/pares-dto';
import { PersonaDto } from 'src/app/dto/persona-dto';
import { CursoService } from 'src/app/services/curso.service';
import { EvadocDocenteService } from 'src/app/services/evadoc-docente.service';
import { EvaluarDocentexDocenteService } from 'src/app/services/evaluar-docentex-docente.service';
import { PersonaService } from 'src/app/services/persona.service';
import { UaaService } from 'src/app/services/uaa.service';
import { CuestionarioComponent } from '../../cuestionario/cuestionario.component';
import { EvaluacionService } from 'src/app/services/evaluacion.service';
import { RespuestaEvaluadoComponent } from '../../respuesta-evaluado/respuesta-evaluado.component';

// Definir una interfaz extendida de EvadocInfoDto
interface EvadocInfoDtoEvaluado extends EvadocInfoDto {
  evaluado: boolean;
}


@Component({
  selector: 'app-evaluar',
  templateUrl: './evaluar.component.html',
  styleUrls: ['./evaluar.component.css']
})
export class EvaluarComponent implements OnInit {

  mensaje: number;
  persona: PersonaDto = new PersonaDto;
  listaInicialInfoDto: EvadocInfoDto[] = [];
  lstParaEnviar: EvadocInfoDto[] = [];
  validacionLista: DocentesDependenciaUaaDto[] = [];
  EvaluadosDocentes: PersonaDto[];
  listaParaFiltrar: EvadocInfoDto[];
  url: String = 'https://gaitana.usco.edu.co/evadoc';
  evaluados: EvaluadosDto[];
  lstPares: ParesDto[] = [];
  periodo: number;
  uaa: number;
  perCodigo: number;

  constructor(
    private uaaService: UaaService,
    private evaDocService: EvadocDocenteService,
    private doxXDocSservice: EvaluarDocentexDocenteService,
    public dialog: MatDialog,
    private personaService: PersonaService,
    private curso: CursoService,
    private evaluacionService: EvaluacionService

  ) { }

  ngOnInit() {
    this.datosPersonales();
    this.listarParaEvaluar();
    this.listaUltimo();
  }

  datosPersonales() {
    this.personaService.datosPersonales().subscribe(data => {
      this.persona = data;
    })
  }


  openDialog(item: EvadocInfoDto) {
    const dialogRef = this.dialog.open(CuestionarioComponent, {
      maxWidth: '95vw',
      width: '950px',
      maxHeight: '90vh',
      disableClose: true,
      data: {
        uid: 3,
        periodo: item.periodo,
        docente: item.docente.codigo,
        nombreDocente: item.docente.apellido + ' ' + item.docente.nombre,
        curso: null,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.filtrarDocentes();
    });
  }

  listarParaEvaluar() {
    this.doxXDocSservice.obtenerDocentesxDocentes().subscribe((data: PersonaDto[]) => {
      this.EvaluadosDocentes = data;
    })
  }

  listaUltimo() {
    this.listaInicialInfoDto = [];
    this.uaaService.currentData.subscribe(data => {
      if (data.uaa) {
        this.evaDocService.obtenerDocentesUaa(data.uaa).subscribe((data: EvadocInfoDto[]) => {
          this.listaInicialInfoDto = data;
          this.listaParaFiltrar = data;
          this.filtrarDocentes();
        });
      }
    });
  }

  filtrarDocentes() {
    this.uaaService.currentData.subscribe(data => {
      let tipo2 = 3;
      let periodo2 = data.periodo;

      this.listaInicialInfoDto = this.listaInicialInfoDto.filter(info => {
        return info.docente.codigo !== data.personaCodigo;
      });

      // Obtener los docentes evaluados
      this.curso.ObtenerDocentesEvaluados(tipo2, periodo2).subscribe((data: EvaluadosDto[]) => {
        this.evaluados = data;

        // Agregar propiedad 'evaluado' en función de si el docente está en la lista de evaluados
        this.listaInicialInfoDto = this.listaInicialInfoDto.map(info => {
          const docenteEvaluado = this.evaluados.some(eva => eva.docente === info.docente.codigo);
          return { ...info, evaluado: docenteEvaluado };
        });

        // Validar si todos los docentes de la lista han sido evaluados
        const allEvaluated = this.listaInicialInfoDto.length === 0 || this.listaInicialInfoDto.every(info => (info as any).evaluado);
        this.evaluacionService.setDocentesEvaluados(allEvaluated);
      });
    });
  }

  dialogRespuestas(docente: any) {
    let evaluacion = this.evaluados.filter(persona => persona.docente == docente);

    const dialogRef = this.dialog.open(RespuestaEvaluadoComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        item: true,
        evaluados: evaluacion,
        evaluadoDocente: docente,
        evaluadoCurso: 0
      },
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
}